import { firstValueFrom } from 'rxjs';
import { consoleGqlClient } from '../../../graphql/consoleGraphqlRequest';
import { RECORD_USER_EVENT } from './recordUserEvent.mutation';
import { RecordUserEventInput } from './userActivity.types';

export async function recordUserEvent(input: RecordUserEventInput): Promise<void> {
  try {
    await firstValueFrom(consoleGqlClient(RECORD_USER_EVENT, { input }));
  } catch {
    /* ignore — user-event */
  }
}
